import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import _ from 'lodash-es';
import {
	LocationWithCountAndCanonicalString,
	SelectionEventData,
} from 'company-finder-common';
import { PickerModalBaseComponent } from '@Common';
import { UserService } from '@Common';
import { DeploymentContext } from '@Common';
import { addLocationsToUser } from '@Common';

@Component({
	selector: 'locations-picker-modal',
	templateUrl: './locations-picker-modal.component.html',
	styleUrls: ['./locations-picker-modal.component.scss'],
	// We want to allow the template to have access to styling we put on the outer component (like .selected),
	// so turn off encapsulation.  We'll be careful not to cause style conflicts.
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class LocationsPickerModalComponent
	extends PickerModalBaseComponent<LocationWithCountAndCanonicalString>
	implements OnInit
{
	private allLocationsWithCounts: LocationWithCountAndCanonicalString[] = [];

	@Input()
	public isOnBoardingWizard: boolean;
	@Input()
	public totalMatchedCompanies: number;

	public constructor(dc: DeploymentContext, userService: UserService) {
		super(dc, userService);
	}

	public async ngOnInit(): Promise<void> {
		// Cache locations/counts with canonical representation for more efficient searching

		const summary = this._deploymentContext.comprehensiveSummary;
		this.allLocationsWithCounts = _.sortBy(
			summary.locations.map((location) => ({
				location: location,
				count: summary.getNumberOfCompaniesAtLocation(location.name),
				canonicalString: location.name.toLowerCase(),
			})),
			(locationEntry) => locationEntry.location.name
		);
	}

	public async doSearch(
		newSearchText: string
	): Promise<LocationWithCountAndCanonicalString[]> {
		if (newSearchText.length === 0) {
			// Only filter down if a filter text was given
			return this.allLocationsWithCounts;
		}

		return this.allLocationsWithCounts.filter(
			(lwc: LocationWithCountAndCanonicalString) =>
				lwc.canonicalString?.includes(newSearchText.toLowerCase())
		);
	}

	public async doSelect(
		selectionEventData: SelectionEventData
	): Promise<void> {
		// This logic is to update the "live" count for the wizard,
		// no need to make API calls otherwise
		if (!this.isOnBoardingWizard) {
			return;
		}

		const wizardUser = _.cloneDeep(this.user);

		addLocationsToUser(selectionEventData.selectedItems, wizardUser);
		this.updateCompanyCountForWizard(wizardUser);
	}
}
